const state = {
  bypassSiteMaintenance: false
}

const getters = {
  getBypassSiteMaintenance: (state) => state.bypassSiteMaintenance
}

const mutations = {
  setBypassSiteMaintenance: (state, payload) => {
    state.bypassSiteMaintenance = payload
  }
}

const actions = {
  setBypassSiteMaintenance: ({ commit }, payload) => {
    commit('setBypassSiteMaintenance', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
